import {
    Table,
    Button,
    Radio,
    Input,
    message,
    Checkbox,
    Popconfirm,
} from "antd";
import React, { Component } from "react";
import API_URL from "../../../../common/url";
import $ from "../../../../common/AjaxRequest";
import SortList from "./SortList";

const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;

const PageConfig = {
    Crc: {
        titleKey: "responsibility",
        queryUrl: API_URL.evaluate.queryCrcServe,
        updateUrl: API_URL.evaluate.updateCrcServe,
        updateDisplayUrl: API_URL.evaluate.updateCrcServeDisplay,
        id: 'quotationVisitCrcServeId',
    },
    Start: {
        titleKey: "centralStartupSupport",
        queryUrl: API_URL.evaluate.queryStartServe,
        updateUrl: API_URL.evaluate.updateStartServe,
        updateDisplayUrl: API_URL.evaluate.updateStartServeDisplay,
        id: 'quotationVisitStartServeId',
    },
    FteCrc: {
        titleKey: "responsibility",
        queryUrl: API_URL.evaluate.queryFteCrcServe,
        updateUrl: API_URL.evaluate.updateFteCrcServe,
        updateDisplayUrl: API_URL.evaluate.updateFteCrcServeDisplay,
        id: 'quotationFteCrcServeId',
    },
    FteStart: {
        titleKey: "centralStartupSupport",
        queryUrl: API_URL.evaluate.queryFteStartServe,
        updateUrl: API_URL.evaluate.updateFteStartServe,
        updateDisplayUrl: API_URL.evaluate.updateFteStartServeDisplay,
        id: 'quotationFteStartServeId',
    },
    CRCServiceContent: {
        title: "CRC服务内容",
        serveType: "SERVE_TYPE_CRC",
    },
    CRCServiceContentInstrument: {
        title: "CRC服务内容-器械",
        serveType: "SERVE_TYPE_CRC_INSTRUMENTS",
    },
    fullStartServiceContent: {
        title: "中心启动服务——SMO全权启动版",
        serveCode: "start_plenipotentiary",
    },
    dominantStartServiceContent: {
        title: "中心启动服务——SMO主导启动版",
        serveCode: "start_leading",
    },
    deepAssistServiceContent: {
        title: "中心启动服务——SMO深度协助版",
        serveCode: "start_deeply_assist",
    },
    basicAssistServiceContent: {
        title: "中心启动服务——SMO基础协助版",
        serveCode: "start_ordinary_assist",
    },
};

export default class CrcServiceContent extends Component {
    state = {
        data: [],
        type: "view",
    };

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { clinicalQuotationRecordId, activeKey, tabType } = this.props;
        const { serveType, serveCode } = PageConfig[activeKey];
        const { queryUrl } = PageConfig[tabType];
        const options = {
            method: "POST",
            url: queryUrl,
            data: { clinicalQuotationRecordId, serveType, serveCode },
            dataType: "json",
            doneResult: (res) => {
                const { crcServeList, startServeList } = res;
                (crcServeList || startServeList).map(
                    (el) => (el.fatherItem = true)
                );
                this.setState({
                    data: crcServeList || startServeList,
                    type: "view",
                });
            },
        };
        $.sendRequest(options);
    };

    handleChange = (key, val, id, item) => {
        const { data } = this.state;
        const { tabType } = this.props;
        const dataMap = (data) => {
            data.map((el, index) => {
                const {
                    quotationVisitCrcServeId,
                    quotationVisitStartServeId,
                    quotationFteCrcServeId,
                    quotationFteStartServeId,
                    children,
                } = el;
                if ( tabType === 'Crc' && quotationVisitCrcServeId == id && item == index ) {
                    el[key] = val;
                } else if (tabType === 'Start' && quotationVisitStartServeId == id && item == index) {
                    el[key] = val;
                } else if (tabType === 'FteCrc' && quotationFteCrcServeId == id && item == index) {
                    el[key] = val;
                } else if (tabType === 'FteStart' && quotationFteStartServeId == id && item == index) {
                    el[key] = val;
                } else if (children && !!children.length) {
                    dataMap(children);
                }
            });
        };
        dataMap(data);
        this.setState({ data });
    };

    addData = (id) => {
        const { data } = this.state;
        const { tabType } = this.props;
        const dataMap = (data) => {
            data.map((el) => {
                const {
                    quotationVisitCrcServeId,
                    quotationVisitStartServeId,
                    quotationFteCrcServeId,
                    quotationFteStartServeId,
                    children,
                } = el;
                el.children = children ? children : [];
                if (tabType === "Crc" && quotationVisitCrcServeId == id) {
                    el.children.push({
                        parentId: id,
                        item: el.children.length + 1,
                    });
                } else if (tabType === "Start" && quotationVisitStartServeId == id) {
                    el.children.push({
                        parentId: id,
                        item: el.children.length + 1,
                    });
                } else if (tabType === "FteCrc" && quotationFteCrcServeId == id) {
                    el.children.push({
                        parentId: id,
                        item: el.children.length + 1,
                    });
                } else if (tabType === "FteStart" && quotationFteStartServeId == id) {
                    el.children.push({
                        parentId: id,
                        item: el.children.length + 1,
                    });
                } else if (children && !!children.length) {
                    dataMap(children);
                }
            });
        };
        dataMap(data);
        this.setState({ data });
    };

    delData = (id, item) => {
        const { data } = this.state;
        const { tabType } = this.props;
        const dataMap = (data) => {
            data.map((el, index) => {
                const {
                    quotationVisitCrcServeId,
                    quotationVisitStartServeId,
                    quotationFteCrcServeId,
                    quotationFteStartServeId,
                    children,
                } = el;
                if ( tabType === 'Crc' && quotationVisitCrcServeId == id && item == index) {
                    data.splice(index, 1);
                } else if (tabType === 'Start' && quotationVisitStartServeId == id && item == index) {
                    data.splice(index, 1);
                }  else if (tabType === 'FteCrc' && quotationFteCrcServeId == id && item == index) {
                    data.splice(index, 1);
                }  else if (tabType === 'FteStart' && quotationFteStartServeId == id && item == index) {
                    data.splice(index, 1);
                } else if (children && !!children.length) {
                    dataMap(children, index);
                }
            });
        };
        dataMap(data);
        this.setState({ data });
    };

    getColumns = () => {
        const { type } = this.state;
        const { tabType } = this.props;
        const columns = [
            {
                title: "编号",
                dataIndex: "indexNumber",
                key: "indexNumber",
                width: 80,
            },
        ];
        tabType === "Crc" &&
            columns.push(
                {
                    title: "职责",
                    dataIndex: "responsibility",
                    key: "responsibility",
                    width: 400,
                    render: (text, record) => {
                        const {
                            display,
                            quotationVisitCrcServeId,
                            showEye,
                            showAddBtn,
                            item,
                        } = record;
                        if (showEye && type === "view") {
                            const { recordData } = this.props;
                            const { bdBaAuth, evaluateStatus } = recordData;
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    {(bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                                        <a onClick={() => this.eyeClick(record)}>
                                            {display ? (
                                                <i className="icon iconfont">
                                                    &#xe6fe;
                                                </i>
                                            ) : (
                                                <i className="icon iconfont">
                                                    &#xe745;
                                                </i>
                                            )}
                                        </a>
                                    }
                                </span>
                            );
                        } else if (showAddBtn && type === "edit" && display) {
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    <a
                                        onClick={() =>
                                            this.addData(
                                                quotationVisitCrcServeId
                                            )
                                        }
                                    >
                                        <i className="icon iconfont">
                                            &#xe642;
                                        </i>
                                    </a>
                                </span>
                            );
                        } else {
                            return type === "view" || showAddBtn || showEye ? (
                                text
                            ) : (
                                <Input
                                    value={text}
                                    placeholder="请输入"
                                    onChange={(e) =>
                                        this.handleChange(
                                            "responsibility",
                                            e.target.value,
                                            quotationVisitCrcServeId,
                                            item - 1
                                        )
                                    }
                                />
                            );
                        }
                    },
                },
                {
                    title: "是/否",
                    dataIndex: "whether",
                    key: "whether",
                    width: 120,
                    render: (text, record, index) => {
                        const {
                            item,
                            quotationVisitCrcServeId,
                            showEye,
                            showAddBtn,
                        } = record;
                        return type === "view" || showEye || showAddBtn ? (
                            text
                        ) : (
                            <RadioGroup
                                onChange={(e) =>
                                    this.handleChange(
                                        "whether",
                                        e.target.value,
                                        quotationVisitCrcServeId,
                                        item - 1
                                    )
                                }
                                value={text}
                            >
                                <Radio value={"是"}>是</Radio>
                                <Radio value={"否"}>否</Radio>
                            </RadioGroup>
                        );
                    },
                }
            );
        tabType === "Start" &&
            columns.push(
                {
                    title: "职责",
                    dataIndex: "responsibility",
                    key: "responsibility",
                    width: 120,
                    render: (text, record) => {
                        const {
                            display,
                            quotationVisitStartServeId,
                            showEye,
                            showAddBtn,
                            item,
                        } = record;
                        const { recordData } = this.props;
                        const { bdBaAuth, evaluateStatus } = recordData;
                        if (showEye && type === "view") {
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    {(bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                                        <a onClick={() => this.eyeClick(record)}>
                                            {display ? (
                                                <i className="icon iconfont">
                                                    &#xe6fe;
                                                </i>
                                            ) : (
                                                <i className="icon iconfont">
                                                    &#xe745;
                                                </i>
                                            )}
                                        </a>
                                    }
                                </span>
                            );
                        } else if (showAddBtn && type === "edit" && display) {
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    <a
                                        onClick={() =>
                                            this.addData(
                                                quotationVisitStartServeId
                                            )
                                        }
                                    >
                                        <i className="icon iconfont">
                                            &#xe642;
                                        </i>
                                    </a>
                                </span>
                            );
                        } else {
                            return quotationVisitStartServeId ? (
                                text
                            ) : (
                                <Input
                                    value={text}
                                    placeholder="请输入"
                                    onChange={(e) =>
                                        this.handleChange(
                                            "responsibility",
                                            e.target.value,
                                            quotationVisitStartServeId,
                                            item - 1
                                        )
                                    }
                                />
                            );
                        }
                    },
                },
                {
                    title: "中心启动支持",
                    dataIndex: "centralStartupSupport",
                    key: "centralStartupSupport",
                    width: 260,
                    render: (text, record, index) => {
                        const {
                            item,
                            quotationVisitStartServeId,
                            showEye,
                            showAddBtn,
                        } = record;
                        return type === "view" || showEye || showAddBtn ? (
                            text
                        ) : (
                            <Input
                                value={text}
                                placeholder="请输入"
                                onChange={(e) =>
                                    this.handleChange(
                                        "centralStartupSupport",
                                        e.target.value,
                                        quotationVisitStartServeId,
                                        item - 1
                                    )
                                }
                            />
                        );
                    },
                },
                {
                    title: "责任方",
                    dataIndex: "responsibleParty",
                    key: "responsibleParty",
                    width: 180,
                    render: (text, record, index) => {
                        const {
                            item,
                            quotationVisitStartServeId,
                            showEye,
                            showAddBtn,
                        } = record;
                        return type === "view" || showEye || showAddBtn ? (
                            text
                        ) : (
                            <CheckboxGroup
                                onChange={(val) =>
                                    this.handleChange(
                                        "responsibleParty",
                                        val.length ? val.join("；") : "",
                                        quotationVisitStartServeId,
                                        item - 1
                                    )
                                }
                                value={text ? text.split("；") : []}
                            >
                                <Checkbox value={"津石"}>津石</Checkbox>
                                <Checkbox value={"申办方"}>申办方</Checkbox>
                                <Checkbox value={"CRO"}>CRO</Checkbox>
                            </CheckboxGroup>
                        );
                    },
                }
            );


            tabType === "FteCrc" &&
            columns.push(
                {
                    title: "职责",
                    dataIndex: "responsibility",
                    key: "responsibility",
                    width: 400,
                    render: (text, record) => {
                        const {
                            display,
                            quotationFteCrcServeId,
                            showEye,
                            showAddBtn,
                            item,
                        } = record;
                        if (showEye && type === "view") {
                            const { recordData } = this.props;
                            const { bdBaAuth, evaluateStatus } = recordData;
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    {(bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                                        <a onClick={() => this.eyeClick(record)}>
                                            {display ? (
                                                <i className="icon iconfont">
                                                    &#xe6fe;
                                                </i>
                                            ) : (
                                                <i className="icon iconfont">
                                                    &#xe745;
                                                </i>
                                            )}
                                        </a>
                                    }
                                </span>
                            );
                        } else if (showAddBtn && type === "edit" && display) {
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    <a
                                        onClick={() =>
                                            this.addData(
                                                quotationFteCrcServeId
                                            )
                                        }
                                    >
                                        <i className="icon iconfont">
                                            &#xe642;
                                        </i>
                                    </a>
                                </span>
                            );
                        } else {
                            return type === "view" || showAddBtn || showEye ? (
                                text
                            ) : (
                                <Input
                                    value={text}
                                    placeholder="请输入"
                                    onChange={(e) =>
                                        this.handleChange(
                                            "responsibility",
                                            e.target.value,
                                            quotationFteCrcServeId,
                                            item - 1
                                        )
                                    }
                                />
                            );
                        }
                    },
                },
                {
                    title: "是/否",
                    dataIndex: "whether",
                    key: "whether",
                    width: 120,
                    render: (text, record, index) => {
                        const {
                            item,
                            quotationFteCrcServeId,
                            showEye,
                            showAddBtn,
                        } = record;
                        return type === "view" || showEye || showAddBtn ? (
                            text
                        ) : (
                            <RadioGroup
                                onChange={(e) =>
                                    this.handleChange(
                                        "whether",
                                        e.target.value,
                                        quotationFteCrcServeId,
                                        item - 1
                                    )
                                }
                                value={text}
                            >
                                <Radio value={"是"}>是</Radio>
                                <Radio value={"否"}>否</Radio>
                            </RadioGroup>
                        );
                    },
                }
            );
        tabType === "FteStart" &&
            columns.push(
                {
                    title: "职责",
                    dataIndex: "responsibility",
                    key: "responsibility",
                    width: 120,
                    render: (text, record) => {
                        const {
                            display,
                            quotationFteStartServeId,
                            showEye,
                            showAddBtn,
                            item,
                        } = record;
                        const { recordData } = this.props;
                        const { bdBaAuth, evaluateStatus } = recordData;
                        if (showEye && type === "view") {
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    {(bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&
                                        <a onClick={() => this.eyeClick(record)}>
                                            {display ? (
                                                <i className="icon iconfont">
                                                    &#xe6fe;
                                                </i>
                                            ) : (
                                                <i className="icon iconfont">
                                                    &#xe745;
                                                </i>
                                            )}
                                        </a>
                                    }
                                </span>
                            );
                        } else if (showAddBtn && type === "edit" && display) {
                            return (
                                <span>
                                    <span style={{ marginRight: 10 }}>
                                        {text}
                                    </span>
                                    <a
                                        onClick={() =>
                                            this.addData(
                                                quotationFteStartServeId
                                            )
                                        }
                                    >
                                        <i className="icon iconfont">
                                            &#xe642;
                                        </i>
                                    </a>
                                </span>
                            );
                        } else {
                            return quotationFteStartServeId ? (
                                text
                            ) : (
                                <Input
                                    value={text}
                                    placeholder="请输入"
                                    onChange={(e) =>
                                        this.handleChange(
                                            "responsibility",
                                            e.target.value,
                                            quotationFteStartServeId,
                                            item - 1
                                        )
                                    }
                                />
                            );
                        }
                    },
                },
                {
                    title: "中心启动支持",
                    dataIndex: "centralStartupSupport",
                    key: "centralStartupSupport",
                    width: 260,
                    render: (text, record, index) => {
                        const {
                            item,
                            quotationFteStartServeId,
                            showEye,
                            showAddBtn,
                        } = record;
                        return type === "view" || showEye || showAddBtn ? (
                            text
                        ) : (
                            <Input
                                value={text}
                                placeholder="请输入"
                                onChange={(e) =>
                                    this.handleChange(
                                        "centralStartupSupport",
                                        e.target.value,
                                        quotationFteStartServeId,
                                        item - 1
                                    )
                                }
                            />
                        );
                    },
                },
                {
                    title: "责任方",
                    dataIndex: "responsibleParty",
                    key: "responsibleParty",
                    width: 180,
                    render: (text, record, index) => {
                        const {
                            item,
                            quotationFteStartServeId,
                            showEye,
                            showAddBtn,
                        } = record;
                        return type === "view" || showEye || showAddBtn ? (
                            text
                        ) : (
                            <CheckboxGroup
                                onChange={(val) =>
                                    this.handleChange(
                                        "responsibleParty",
                                        val.length ? val.join("；") : "",
                                        quotationFteStartServeId,
                                        item - 1
                                    )
                                }
                                value={text ? text.split("；") : []}
                            >
                                <Checkbox value={"津石"}>津石</Checkbox>
                                <Checkbox value={"申办方"}>申办方</Checkbox>
                                <Checkbox value={"CRO"}>CRO</Checkbox>
                            </CheckboxGroup>
                        );
                    },
                }
            );


        columns.push({
            title: "备注",
            dataIndex: "remark",
            key: "remark",
            width: 200,
            render: (text, record, index) => {
                const {
                    item,
                    quotationVisitCrcServeId,
                    quotationVisitStartServeId,
                    quotationFteCrcServeId,
                    quotationFteStartServeId,
                    showEye,
                    showAddBtn,
                } = record;
                let id = '';
                switch (tabType) {
                    case 'Crc':
                        id = quotationVisitCrcServeId;
                        break;
                    case 'Start':
                        id = quotationVisitStartServeId;
                        break;
                    case 'FteCrc':
                        id = quotationFteCrcServeId;
                        break;
                    case 'FteStart':
                        id = quotationFteStartServeId;
                        break;
                }
                return type === "view" || showEye || showAddBtn ? (
                    text
                ) : (
                    <Input
                        value={text}
                        placeholder="请输入"
                        onChange={(e) =>
                            this.handleChange(
                                "remark",
                                e.target.value,
                                id,
                                item - 1
                            )
                        }
                    />
                );
            },
        });
        if (type === "edit") {
            columns.push({
                title: "",
                dataIndex: "operation",
                key: "operation",
                width: 80,
                render: (_, record, index) => {
                    const {
                        quotationVisitCrcServeId,
                        quotationVisitStartServeId,
                        quotationFteCrcServeId,
                        quotationFteStartServeId,
                        item,
                        showEye,
                        showAddBtn,
                    } = record;
                    let id = '';
                    switch (tabType) {
                        case 'Crc':
                            id = quotationVisitCrcServeId;
                            break;
                        case 'Start':
                            id = quotationVisitStartServeId;
                            break;
                        case 'FteCrc':
                            id = quotationFteCrcServeId;
                            break;
                        case 'FteStart':
                            id = quotationFteStartServeId;
                            break;
                    }
                    return showEye || showAddBtn ? (
                        ""
                    ) : (
                        <Popconfirm
                            title="确定删除该记录?"
                            onConfirm={() =>
                                this.delData(id, item - 1)
                            }
                        >
                            <a>删除</a>
                        </Popconfirm>
                    );
                },
            });
        }
        return columns;
    };

    getDataSource = () => {
        const dataSource = [];
        const { data } = this.state;
        const copyData = JSON.parse(JSON.stringify(data));
        const handleData = (data, fathernNmber) => {
            let number = 1;
            (data || []).map((item, fatherIndex) => {
                const { display, children, type } = item;
                delete item.children;
                if (display) {
                    dataSource.push({
                        ...item,
                        showAddBtn: type === 'DIR' ,
                        showEye: children && !!children.length,
                        item: fatherIndex + 1,
                        indexNumber: fathernNmber
                            ? `${fathernNmber}-${number}`
                            : number,
                    });
                    if (children && !!children.length) {
                        handleData(
                            children,
                            fathernNmber ? `${fathernNmber}-${number}` : number
                        );
                    }
                    number++;
                } else {
                    dataSource.push({
                        ...item,
                        item: fatherIndex + 1,
                        showEye: children && !!children.length,
                        showAddBtn: type === 'DIR',
                        indexNumber: fathernNmber && !children
                            ? `${fathernNmber}-${fatherIndex + 1}`
                            : "-",
                    });
                }
            });
        };
        handleData(copyData);
        return dataSource;
    };

    rowClassName = (record) => {
        const { fatherItem, showEye, type } = record;
        if (fatherItem) {
            return "fatherRow";
        } else if (showEye || type == 'DIR') {
            return "showEyeRow";
        }
    };

    eyeClick = (record) => {
        const { tabType, clinicalQuotationRecordId } = this.props;
        const { updateDisplayUrl } = PageConfig[tabType];
        const {
            quotationVisitCrcServeId,
            quotationVisitStartServeId,
            quotationFteCrcServeId,
            quotationFteStartServeId,
            display,
        } = record;
        const options = {
            method: "POST",
            url: updateDisplayUrl,
            data: {
                quotationVisitCrcServeId,
                quotationVisitStartServeId,
                quotationFteCrcServeId,
                quotationFteStartServeId,
                display: display === 1 ? 0 : 1,
                clinicalQuotationRecordId,
            },
            dataType: "json",
            doneResult: (res) => {
                this.loadData();
            },
        };
        $.sendRequest(options);
    };

    submit = (list, sort = false) => {
        const { clinicalQuotationRecordId, activeKey, tabType } = this.props;
        const { updateUrl } = PageConfig[tabType];
        const { serveType, serveCode } = PageConfig[activeKey];
        const tableData = this.getDataSource();
        if (!sort) {
            try {
                tableData.map((el) => {
                    const {
                        showEye,
                        showAddBtn,
                        responsibility,
                        responsibleParty,
                        centralStartupSupport,
                        whether,
                        indexNumber,
                    } = el;
                    if (!showEye && !showAddBtn) {
                        if (tabType === "Crc" || tabType === "FteCrc") {
                            if (!responsibility) {
                                throw `请填写${indexNumber}“职责”字段`;
                            }
                            if (!whether) {
                                throw `请填写${indexNumber}“是/否”字段`;
                            }
                        } else {
                            if (!responsibility) {
                                throw `请填写${indexNumber}“职责”字段`;
                            }
                            if (!centralStartupSupport) {
                                throw `请填写${indexNumber}“任务细分”字段`;
                            }
                            if (!responsibleParty) {
                                throw `请填写${indexNumber}“责任方”字段`;
                            }
                        }
                    }
                });
            } catch (error) {
                return message.warning(error);
            }
        }
        let serveStrName = '';
        switch (tabType) {
            case 'Crc':
            case 'FteCrc':
                serveStrName = 'crcServeStr';
                break;
            case 'Start':
            case 'FteStart':
                serveStrName = 'startServeStr';
                break;
        }
        const options = {
            method: "POST",
            url: updateUrl,
            data: {
                clinicalQuotationRecordId,
                serveType,
                serveCode,
                [serveStrName]:
                    JSON.stringify(list),
            },
            dataType: "json",
            doneResult: (res) => {
                message.success(res.success);
                this.loadData();
            },
        };
        $.sendRequest(options);
    };

    render() {
        const { type, data } = this.state;
        const { activeKey, tabType, recordData } = this.props;
        const { title } = PageConfig[activeKey];
        const { titleKey, id } = PageConfig[tabType];
        const { bdBaAuth, evaluateStatus } = recordData;

        return (
            <div>
                <div
                    style={{
                        fontSize: 20,
                        fontWeight: 600,
                        textAlign: "center",
                        margin: "20px 0",
                    }}
                >
                    { 
                        (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') &&  <Button
                            type="primary"
                            style={{
                                float: "left",
                            }}
                            disabled={type !== "view"}
                            onClick={() => this.sortListRef.show(data)}
                        >
                            排序调整
                        </Button>
                    }
                    {title}
                </div>
                <Table
                    bordered
                    scroll={{ y: 500 }}
                    rowKey={(record) => record[id]}
                    rowClassName={(record) => this.rowClassName(record)}
                    dataSource={this.getDataSource()}
                    columns={this.getColumns()}
                    pagination={false}
                />
                {
                    (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className="Forecast_Params_footer">
                        {type === "view" ? (
                            <Button
                                type="primary"
                                onClick={() =>
                                    this.setState({
                                        type: "edit",
                                    })
                                }
                            >
                                编辑
                            </Button>
                        ) : (
                            <div>
                                <Button
                                    style={{ marginRight: 20 }}
                                    onClick={() => {
                                        this.loadData();
                                        this.setState({
                                            type: "view",
                                        });
                                    }}
                                >
                                    取消
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => this.submit(data)}
                                >
                                    确定
                                </Button>
                            </div>
                        )}
                    </div>
                }
                <SortList
                    confirm={this.submit}
                    titleKey={titleKey}
                    ref={(el) => (this.sortListRef = el)}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/CrcServiceContent/index.js